import { useField } from 'formik';

import { DualListBox, FormModal } from '@components';
import { getDualListBoxConfig } from '@constants';
import { FormType } from '@enums';
import { useFormSubmission } from '@hooks';

interface BlockRegionModalProps {
  label: any;
  open: boolean;
  onClose: () => void;
  formik: any;
  name: string;
  formType: FormType;
  onSubmit: (event, formik, name) => void;
}

export const BlockRegionModal = ({ name, formType, formik, onSubmit, label, open, onClose }: BlockRegionModalProps) => {
  const [field] = useField<string[]>(name);
  const dualListBoxConfig = getDualListBoxConfig();

  useFormSubmission({ formType });

  return (
    <FormModal
      title={label?.title}
      formType={formType}
      open={open}
      onClose={onClose}
      description={label?.description}
      size="2xl"
      confirmButton={{
        children: label?.confirmButton,
        onClick: () => {
          onSubmit(field.value, formik, name);
        },
      }}
    >
      <DualListBox {...dualListBoxConfig} />
    </FormModal>
  );
};
